import { utils, write } from "xlsx";

function convertToExcel(data: any) {
  const worksheet = utils.json_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  return blob;
}

// Function to convert an array of objects to CSV format
function convertToCSV<T>(objArray: T[]): Blob | null {
  const array: T[] = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  let csv = "";
  if (array.length === 0) return null; // Return empty string if array is empty
  // Header
  csv += Object.keys(array[0]!).join(",") + "\n";
  // Rows
  array.forEach((item) => {
    csv += Object.values(item!).join(",") + "\n";
  });

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  return blob;
}

// Function to create and download a CSV file
function downloadBlob(blob: Blob, filename: string): void {
  const link = document.createElement("a");
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

// Function to parse CSV data into an array of objects
function parseCSV<T>(csvData: string): T[] {
  const lines = csvData.split("\n");
  const headers = lines[0].split(",").map((header) => header.trim());
  const data: T[] = [];
  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(",").map((value) => value.trim());
    const obj: any = {};
    headers.forEach((header, index) => {
      obj[header] = isNaN(Number(values[index])) ? values[index] : Number(values[index]);
    });
    data.push(obj);
  }
  return data;
}

// Function to handle file input and parse CSV
function handleFileInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = () => {
      const csvData = reader.result as string;
      const parsedData: any[] = parseCSV<any>(csvData); // You can use the parsed data as needed
    };
    reader.readAsText(file);
  }
}

function downloadCSV(data: any[], filename: string) {
  const blob = convertToCSV(data);

  if (blob) {
    downloadBlob(blob, filename);
  }
}

function downloadExcel(data: any[], filename: string) {
  const blob = convertToExcel(data);
  downloadBlob(blob, filename);
}

function downloadExcelMultiSheet(sheets: { name: string; data: any[] }[], filename: string) {
  const workbook = utils.book_new();
  sheets.forEach((sheet) => {
    const worksheet = utils.json_to_sheet(sheet.data);
    utils.book_append_sheet(workbook, worksheet, sheet.name);
  });
  const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  downloadBlob(blob, filename);
}

function downloadPdf(blob: Blob, filename: string) {
  downloadBlob(blob, filename);
}

const fileCore = {
  convertToCSV,
  downloadCSV,
  downloadExcel,
  downloadExcelMultiSheet,
  downloadPdf,
  parseCSV,
  handleFileInput,
};

export default fileCore;
